import 'url-polyfill'
import 'current-script-polyfill'
import 'intersection-observer'

import React, { StrictMode, Suspense } from 'react'
import ReactDOM from 'react-dom'

// ensure global styles are before App so
// component styles take precedence
import './index.css'

import { App } from './components/App/App'
import { Loading } from '@local/do-secundo-loading'
import { handleMobilSafariNav } from './browser_overrides'

// allows us to dynamically set the public path of our code split bundles
// https://github.com/webpack/webpack/issues/7077
if (process.env.NODE_ENV === 'production') {
  const { href } = new URL(document.currentScript.src)
  const regex = /(\/\w+\.(js|css))$/
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = `${href.replace(
    regex,
    ''
    // eslint-disable-next-line no-undef
  )}${__webpack_public_path__}`
}

const root = document.getElementById('root')

handleMobilSafariNav()

ReactDOM.render(
  <StrictMode>
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
  </StrictMode>,
  root
)
